import isArrayEmpty from './isArrayEmpty';

const getAssignmentDetails = ({ selectedAssignments, assignments }) => {
  if (isArrayEmpty(selectedAssignments)) {
    return [];
  }

  // get all ids
  const selectedAssignmentIds = selectedAssignments.map(({ id }) => id);

  return assignments.filter(({ id }) => selectedAssignmentIds.includes(id));
};

export default getAssignmentDetails;
